import { render, staticRenderFns } from "./ColorSwitcher.vue?vue&type=template&id=21c62c14&"
import script from "./ColorSwitcher.vue?vue&type=script&lang=js&"
export * from "./ColorSwitcher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports